export default __webpack_public_path__ + "img/4298910d369e398c0fae4314009b4302.svg";